// PatientData Model
import { Model } from '@vuex-orm/core'

export default class PatientEmrPtTemplate extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'PatientEmrPtTemplates' 

  // List of all fields (schema) of the post model. `this.attr` is used
  // for the generic field type. The argument is the default value.
  static fields () {
    return {
      id : this.attr(null),
      pt_template_id : this.attr(null),
      pt_template_name : this.attr(null),
      pt_template_status : this.attr(null),
      datas : this.attr(null)
    }
  }
}